import { useState } from 'react';
import PropTypes from 'prop-types';
import { AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import endpoints from '@app/constants/endpoints';
import useHelpCenterLink from '../../csr-landing/hooks/useHelpCenterLink';
import { useSelector } from 'react-redux';
import { getCookie, replaceTokensInString } from '@app/utils';
import { copyToClipboard } from '../../checkout/utils';

const SummaryAndPaymentCriticalErrorMessage = ({ selector }) => {
  const [t] = useTranslation();
  const storeId = useSelector(s => s.common?.storeId);
  const langId = useSelector(s => s.common?.langId);
  const catalogId = useSelector(s => s.common?.catalogId);
  const isHelpCenterEnabled = useSelector(
    s => s.featureFlag?.PCCCustomerSupportHelpCenter
  );
  const isCatCorp = useSelector(s => s.common?.isCatCorp);
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const [alreadyClicked, setAlreadyClicked] = useState(false);

  const showHelpCenter = isCatCorp || isHelpCenterEnabled;
  const { getHelpCenterContactSupportURL } = useHelpCenterLink();
  const referenceId = getCookie('X-Cat-Pcc-Session-Id');
  const oldContactUsPageLink = replaceTokensInString(
    endpoints.CONTACT_US_DEALER,
    catalogId,
    langId,
    storeId
  );

  const contactUsLink = showHelpCenter
    ? getHelpCenterContactSupportURL()
    : `${esiteURL}${oldContactUsPageLink}`;

  const handleClickContactUs = () => {
    if (showHelpCenter) {
      window.open(contactUsLink, '_blank');
    } else if (catalogId && storeId && langId) {
      const pageTitle = document.title;
      sessionStorage.setItem('referenceId', referenceId);
      sessionStorage.setItem('pageTitle', pageTitle);
      window.location.href = `CATContactUsDisplayView?catalogId=${catalogId}&langId=${langId}&storeId=${storeId}`;
    }
  };

  const handleCopyReferenceId = () => {
    copyToClipboard(referenceId);
    setAlreadyClicked(true);
  };

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <ExceptionFeedbackBySelector selector={selector}>
      <div className="d-flex gap-2 my-3">
        <AlloyButton buttonType="secondary" size="small" onClick={refreshPage}>
          {t('REFRESH')}
        </AlloyButton>
        <AlloyButton
          buttonType="ghost"
          size="small"
          onClick={handleClickContactUs}
        >
          {t('FOOTER_CONTACT_US')}
        </AlloyButton>
      </div>
      <div className="d-flex align-items-center mt-2">
        <span style={{ color: '#0078D6' }}>
          {t('SHOPPING_CART_REFERENCE_ID')}: {referenceId}
        </span>
        {!alreadyClicked && (
          <AlloyButton
            buttonType="ghost"
            size="small"
            onClick={handleCopyReferenceId}
            className="ms-2"
          >
            {t('COPY')}
          </AlloyButton>
        )}
      </div>
    </ExceptionFeedbackBySelector>
  );
};

SummaryAndPaymentCriticalErrorMessage.prototypes = {
  selector: PropTypes.func.isRequired
};

export default SummaryAndPaymentCriticalErrorMessage;
